<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang="less">
@import './styles/toast.less';

#app {
  font-family: 'Pingfang SC', 'Microsoft YaHei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f3f4f6;
  font-size: 0.15rem;
  height: 100%;
}
html,
body {
  height: 100%;
}
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-weight: inherit;
  font-style: inherit;
  font-size: 100%;
  font-family: inherit;
  vertical-align: baseline;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
:focus {
  outline: 0;
}
table {
  border-collapse: separate;
  border-spacing: 0;
}
caption,
th,
td {
  text-align: left;
  font-weight: normal;
}
a img,
iframe {
  border: none;
}
a {
  text-decoration: none;
}
ol,
ul {
  list-style: none;
}
input,
textarea,
select,
button {
  font-size: 100%;
  font-family: inherit;
}
select {
  margin: inherit;
}
/* Fixes incorrect placement of numbers in ol’s in IE6/7 */
ol {
  margin-left: 2em;
}
html {
  font-size: 625%;
}
@media (max-width: 320px) {
  html {
    font-size: 500%;
  }
}

.fix-full-screen-padding-bottom {
  padding-bottom: env(safe-area-inset-bottom) !important;
  box-sizing: border-box;
}

.fix-full-screen-height {
  height: env(safe-area-inset-bottom) !important;
}

.fix-full-screen-bottom {
  bottom: env(safe-area-inset-bottom) !important;
  &::after {
    content: ' ';
    position: fixed;
    left: 0;
    bottom: 0 !important;
    height: env(safe-area-inset-bottom) !important;
    width: 100%;
    background: #fff;
  }
  &.is-black {
    &::after {
      background: #000;
    }
  }
}
</style>
